/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
// libraries
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { isColorLight, useWindowSize } from '../../utils/FunctionsGlobals';
import { appendCodsiteQuery } from '../../utils/url';
// utils
import { useAuth } from '../context/Info';
import { trackLead } from '../whatsAppButton/WhatsAppButton';
import styles from './DrawerComponent.module.css';

// interface
interface IDrawerComponent {
    site: any;
    activeDrawer: boolean;
    setActiveDrawer: any;
    favorito: Array<number>;
    vips?: any;
    menus: any;
}

type DrawerMenuItem = {
    titulo: string;
    link: string;
    Disponivel: boolean;
    Conteudo: string;
    Menu: boolean;
    Topo: boolean;
    Rodape: boolean;
    Destino: string;
};

type Site2551MenuSpec = {
    matches: string[];
    displayTitle?: string;
};

const DrawerComponent: React.FC<IDrawerComponent> = ({
    site,
    activeDrawer,
    setActiveDrawer,
    favorito,
    vips,
    menus
}): any => {
    // constants
    const size = useWindowSize();
    const [vips2, setVips2] = useState<any>(vips || "");
    const renderText = () => {
        return `/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/-/-?favoritos=${favorito}`;
    };
    const isNovember = new Date().getMonth() === 10;
    const logoSrc = site?.id == 2449 ? "https://imob.sobressai.com.br/Banner/2449/12082.jpg" : site?.id == "2434" ? "https://imob.sobressai.com.br/Banner/2434/11945.jpg": site?.id == 2315 ? "https://fotos.sobressai.com.br/Banner/2315/11488.jpg" : site?.id == 2231 ? "https://fotos.sobressai.com.br/importacoes/import_xml/xml/logo/2231.png" : site?.id == 2245 ? "https://fotos.sobressai.com.br/Banner/2245/11400.jpg" : site?.id == 2155 ? "https://fotos.sobressai.com.br/Banner/2155/11155.jpg" : `${site?.url_logo}?v=${site?.contador_marca || 0}`;
    const logoSrcClosed = site?.id == 2155 ? "https://fotos.sobressai.com.br/Banner/2155/11155.jpg" : `${site?.url_logo}?v=${site?.contador_marca || 0}`;

    const {
        allDataHome,
    } = useAuth();
    const router = useRouter();
    const codsiteQuery = Array.isArray(router.query?.codsite)
        ? router.query?.codsite[0]
        : router.query?.codsite;

    // codsite só é anexado após a montagem: appendCodsiteQuery resolve o host via
    // window.location no cliente, então sem isto o href do SSR (sem codsite) difere
    // do cliente em host de teste/preview ("Prop href did not match").
    const [isCodsiteReady, setIsCodsiteReady] = useState(false);
    useEffect(() => {
        setIsCodsiteReady(true);
    }, []);

    const withCodsite = (href?: string): string => {
        const safeHref = href || '/';
        if (!safeHref.startsWith('/')) return safeHref;
        return isCodsiteReady ? appendCodsiteQuery(safeHref, codsiteQuery) : safeHref;
    };

    const footerFlags = [
        { code: 'us', label: 'EUA' },
        { code: 'jp', label: 'Japao' },
        { code: 'br', label: 'Brasil' },
        { code: 'ar', label: 'Argentina' },
        { code: 'cl', label: 'Chile' },
        { code: 'py', label: 'Paraguai' },
        { code: 'uy', label: 'Uruguai' },
    ];


    const cor_letras = isColorLight(site?.cor10) ? site?.cor11 : site?.cor13
    const cor_titulos = (isColorLight(site?.cor2) && isColorLight(site?.cor10)) || (!isColorLight(site?.cor2) && !isColorLight(site?.cor10)) ? cor_letras : site?.cor2
    const renderedMenuKeys = new Set<string>();
    const isSite2551 = Number(site?.id) === 2551;

    const normalizeMenuValue = (value?: string) => (value || '').trim().toLowerCase();
    const normalizeMenuTitle = (value?: string) =>
        normalizeMenuValue(value)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

    const shouldHideFromPropertiesSection = (menu?: Partial<DrawerMenuItem>) => {
        if (!isSite2551) return false;

        const title = normalizeMenuTitle(menu?.titulo);
        const link = normalizeMenuValue(menu?.link);
        const destination = normalizeMenuTitle(menu?.Destino);
        const isHiddenSite2551Menu = title === 'senhas';
        const isPropertyMenu =
            link.includes('/imove') ||
            destination === 'imovel' ||
            destination === 'imoveis';
        const isHandledByAnotherSite2551Section = [
            ...site2551OnlineServicesTitles,
            ...site2551ContactTitles,
            ...site2551GeneralInfoTitles,
        ].includes(title);

        return isHiddenSite2551Menu || !isPropertyMenu || isHandledByAnotherSite2551Section;
    };

    const shouldHideFromServicesSection = (menu?: Partial<DrawerMenuItem>) => {
        if (!isSite2551) return false;

        return !site2551OnlineServicesTitles.includes(normalizeMenuTitle(menu?.titulo));
    };

    const shouldShowInContactSection = (menu?: Partial<DrawerMenuItem>) => {
        if (!isSite2551) return false;

        return site2551ContactTitles.includes(normalizeMenuTitle(menu?.titulo));
    };

    const site2551OnlineServiceSpecs: Site2551MenuSpec[] = [
        { matches: ['area do proprietario'] },
        { matches: ['area do locatario'] },
        { matches: ['manutencao'] },
    ];
    const site2551OnlineServicesTitles = site2551OnlineServiceSpecs.reduce<string[]>(
        (titles, spec) => titles.concat(spec.matches),
        []
    );
    const site2551ContactTitles = ['contatos', 'contato', 'vendas', 'aluguel'];
    const site2551ContactExtraSpecs: Site2551MenuSpec[] = [
        { matches: ['anuncie seu imovel', 'teste anuncie seu imovel'] },
        { matches: ['trabalhe conosco', 'teste trabalhe conosco'] },
    ];
    const site2551GeneralInfoTitles = ['equipe vendas', 'equipe'];

    const getSite2551OrderedMenus = (titles: Array<string>) => {
        return titles
            .map((title) => {
                const menu = menus?.find((menu: DrawerMenuItem) =>
                    menu?.Disponivel && normalizeMenuTitle(menu?.titulo) === title
                );

                return menu;
            })
            .filter(Boolean);
    };

    const getSite2551OrderedMenuEntries = (specs: Array<Site2551MenuSpec>) => {
        return specs
            .map((spec) => {
                const menu = menus?.find((menu: DrawerMenuItem) =>
                    menu?.Disponivel && spec.matches.includes(normalizeMenuTitle(menu?.titulo))
                );

                return menu ? { menu, displayTitle: spec.displayTitle } : null;
            })
            .filter(Boolean) as Array<{ menu: DrawerMenuItem; displayTitle?: string }>;
    };

    const getSite2551ServiceDisplayTitle = (menu: DrawerMenuItem, displayTitle?: string) => {
        if (displayTitle) return displayTitle;
        return String(menu?.titulo || '').replace(/^teste\s+/i, '');
    };

    const getSite2551TransactionOrder = () => {
        const transactionTitles = ['venda', 'aluguel'];

        return transactionTitles.filter((transactionTitle) =>
            site?.transacoes?.some((transaction: string) => normalizeMenuValue(transaction) === transactionTitle)
        );
    };

    const getMenuUniqueKey = (menu?: Partial<DrawerMenuItem>) => {
        const normalizedLink = normalizeMenuValue(menu?.link);
        if (normalizedLink) {
            return normalizedLink;
        }

        const normalizedTitle = normalizeMenuValue(menu?.titulo);
        return normalizedTitle ? `/menu/${normalizedTitle}` : '';
    };

    const shouldRenderUniqueMenu = (menu?: Partial<DrawerMenuItem>) => {
        const uniqueKey = getMenuUniqueKey(menu);
        if (!uniqueKey) {
            return false;
        }

        if (renderedMenuKeys.has(uniqueKey)) {
            return false;
        }

        renderedMenuKeys.add(uniqueKey);
        return true;
    };

    // methods
    const closeDrawer = () => {
        setActiveDrawer(false);
    };

    const renderDrawerMenuLink = (menu: DrawerMenuItem, key: string, displayTitle?: string) => {
        const title = displayTitle || menu?.titulo;
        const href = menu?.link ? menu?.link : `/menu/${menu?.titulo}`;

        return (
            <Link prefetch={false} href={withCodsite(href)} style={{width: "100%"}} key={key} passHref>
                <div
                    style={{width: "100%"}}
                    aria-label={`Botão para ir à página ${title}`}
                    title={`Clique aqui para ir à página ${title}`}
                >
                    <div className={styles.info_body} onClick={closeDrawer} style={{color: cor_letras}}>{title}</div>
                </div>
            </Link>
        );
    };

    const renderBlogLink = () => (
        allDataHome?.blogs[0]?.id ? (
            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/blog')} passHref>
                <div
                    style={{width: "100%"}}
                    aria-label={`Botao para navegar ao Blog da imobiliaria`}
                    title={`Clique aqui para navegar ao Blog da imobiliaria`}
                >
                    <div className={styles.info_body} style={{color: cor_letras}}>Blog</div>
                </div>
            </Link>
        ) : null
    );

    const renderPrivacyLink = () => (
        site?.id != 2456 ? (
            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/politica')} passHref>
                <div
                    style={{width: "100%"}}
                    aria-label={`Botao para ir a pagina Politica de Privacidade`}
                    title={`Clique aqui para ir a pagina Politica de Privacidade`}
                >
                    <div className={styles.info_body} style={{color: cor_letras}}>
                        Politica de privacidade
                    </div>
                </div>
            </Link>
        ) : null
    );

    const renderTermsLink = () => (
        site?.id != 2456 ? (
            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/termos')} passHref>
                <div
                    style={{width: "100%"}}
                    aria-label={`Botao para ver os termos de uso`}
                    title={`Clique aqui para ver os termos de uso`}
                >
                    <div className={styles.info_body} style={{color: cor_letras}}>Termos de uso</div>
                </div>
            </Link>
        ) : null
    );

    const renderAdvertiseLink = () => (
        <a
            rel="noopener noreferrer"
            href={
                site?.id == 2212
                    ? "https://lp.igorcardosoimoveis.com.br/anuncie"
                    : site?.id == 2133
                    ? "https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link"
                    : site?.id == 2378
                    ? "https://mkt.elionaiconsultoria.com.br/"
                    : site?.id == 1937
                    ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Ola, gostaria de anunciar um imovel.`
                    : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Ola, gostaria de anunciar um imovel.`
            }
            onClick={async (e) => {
                e.preventDefault(); // Evita redirecionamento automatico

                trackLead(site, null); // Registra o evento Lead

                setTimeout(() => {
                    window.open(
                        site?.id == 2212
                            ? "https://lp.igorcardosoimoveis.com.br/anuncie"
                            : site?.id == 2133
                            ? "https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link"
                            : site?.id == 2378
                            ? "https://mkt.elionaiconsultoria.com.br/"
                            : site?.id == 1937
                            ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Ola, gostaria de anunciar um imovel.`
                            : 
                            site?.id == 2490
                            ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Ola, gostaria de anunciar um imovel. Pode me ajudar?`
                            : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Ola, gostaria de anunciar um imovel.`,
                        "_blank"
                    );
                }, 300); // atraso para garantir trackLead
            }}
            aria-label={`Botao para anunciar seu imovel`}
            title={`Clique aqui para anunciar seu imovel`}
            className={styles.info_body}
            style={{ color: cor_letras }}
        >
            Anuncie seu imóvel
        </a>
    );

    const renderSite2551TeamLink = () => {
        const teamMenu = getSite2551OrderedMenus(site2551GeneralInfoTitles)[0];

        return teamMenu && shouldRenderUniqueMenu(teamMenu)
            ? renderDrawerMenuLink(teamMenu, 'site-2551-equipe-vendas', 'Equipe Vendas')
            : null;
    };

    const findMenuByTitles = (titles: string[]) =>
        menus?.find((menu: DrawerMenuItem) =>
            menu?.Disponivel && titles.includes(normalizeMenuTitle(menu?.titulo))
        );

    const renderSimpleLink = (href: string, title: string, key: string) => (
        <Link prefetch={false} style={{width: "100%"}} href={withCodsite(href)} key={key} passHref>
            <div
                style={{width: "100%"}}
                aria-label={`Botão para ir à página ${title}`}
                title={`Clique aqui para ir à página ${title}`}
            >
                <div className={styles.info_body} onClick={closeDrawer} style={{color: cor_letras}}>{title}</div>
            </div>
        </Link>
    );

    const renderSite2558CmsLink = (titles: string[], displayTitle: string, fallbackHref: string) => {
        const menu = findMenuByTitles(titles);
        const href = menu?.link ? menu.link : fallbackHref;

        return renderSimpleLink(href, displayTitle, `site-2558-${normalizeMenuTitle(displayTitle)}`);
    };

    const getDefaultWhatsappUrl = (message: string) =>
        site?.id == "1937"
            ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(/\D/g, '')}&text=${message}`
            : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(/\D/g, '')}&text=${message}`;

    const renderWhatsappAction = (title: string, message: string, key: string) => {
        const whatsappUrl = getDefaultWhatsappUrl(message);

        return (
            <a
                key={key}
                rel="noopener noreferrer"
                href={whatsappUrl}
                onClick={async (e) => {
                    e.preventDefault();
                    trackLead(site, null);
                    setTimeout(() => {
                        window.open(whatsappUrl, "_blank");
                    }, 300);
                }}
                aria-label={`Botão ${title}`}
                title={`Clique aqui para ${title.toLowerCase()}`}
                className={styles.info_body}
                style={{color: cor_letras}}
            >
                {title}
            </a>
        );
    };

    const renderSite2558DrawerMenu = () => (
        <>
            <div className={styles.info_header} style={{ color: cor_titulos }}>IMÓVEIS:</div>
            {renderSimpleLink('/imoveis/venda/-/-/-/-', 'Imóveis para venda', 'site-2558-venda')}
            {renderSimpleLink('/imoveis/aluguel/-/-/-/-', 'Imóveis para locação', 'site-2558-locacao')}
            {renderSite2558CmsLink(['Não encontrou o imóvel ideal', 'Não encontrou o imóvel ideal'], 'Não encontrou o imóvel ideal', '/menu/Não encontrou o imóvel ideal')}

            <div className={styles.info_header} style={{color: cor_titulos}}>SERVIÇOS</div>
            {renderSite2558CmsLink(['Avalie seu imovel', 'Avalie seu imóvel'], 'Avalie seu imóvel', '/menu/avalie seu imóvel')}
            {renderAdvertiseLink()}
            {renderSite2558CmsLink(['indique um imovel', 'indique um imóvel'], 'Indique um imóvel', '/menu/Indique um imóvel')}
            <div className={styles.info_header} style={{color: cor_titulos}}>INSTITUCIONAL</div>
            {renderSite2558CmsLink(['quem somos', 'sobre', 'a imobiliaria', 'a imobiliária'], 'Quem somos', '/empresa')}
            {renderTermsLink()}
            {renderPrivacyLink()}
            {renderSite2558CmsLink(['parcerias'], 'Parcerias', '/menu/Parcerias')}
            {renderSite2558CmsLink(['fale conosco', 'contato', 'contatos'], 'Fale conosco', '/menu/Fale conosco')}
        </>
    );

    // useEffect
    useEffect(() => {
        if (activeDrawer === false) {
            setTimeout(() => {
                setActiveDrawer(null);
            }, 450);
        }
    }, [activeDrawer]);

    useEffect(() => {
        if(!vips2){
            const vip: any = localStorage.getItem('vip');
            if(vip){
                setVips2(vip)
            }
        }
    }, [vips2]);

    if (activeDrawer && Number(site?.id) === 2558) {
        return (
            <div className={styles.container_all_drawer}>
                {size?.width > 600 ? (
                    <div
                        onClick={closeDrawer}
                        className={styles.container_background}
                    />
                ) : null}
                <div className={styles.container_drawer} style={{backgroundColor: site?.cor10}}>
                    <div style={{width: '100%'}}>
                        <div className={styles.closed_modal} onClick={closeDrawer}>
                            <MdClose size={32} color={cor_letras} />
                        </div>
                        <Link href={withCodsite('/')} prefetch={false} title="Clique aqui para ser direcionado para a home do site.">
                            {logoSrc ? (
                                <Image
                                    src={logoSrc}
                                    alt={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                                    title={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                                    className={styles.logo_welcome}
                                    width={240}
                                    height={70}
                                    sizes="240px"
                                />
                            ) : null}
                        </Link>
                        {renderSite2558DrawerMenu()}
                    </div>
                </div>
            </div>
        );
    }

    if (activeDrawer) {
        return (
            <div className={styles.container_all_drawer}>
                {size?.width > 600 ? (
                    <div
                        onClick={closeDrawer}
                        className={styles.container_background}
                    />
                ) : null}
                <div className={styles.container_drawer} style={{backgroundColor: site?.cor10}}>
                    <div style={{width: '100%'}}>
                        <div className={styles.closed_modal} onClick={closeDrawer}>
                            <MdClose size={32} color={cor_letras} />
                        </div>
                        <Link href={withCodsite('/')} prefetch={false} title="Clique aqui para ser direcionado para a home do site.">
                            {logoSrc ? (
                                <Image
                                    src={logoSrc}
                                    alt={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                                    title={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                                    className={styles.logo_welcome}
                                    style={site?.id == 2449 ? {maxHeight: "140px"} : site?.id == 2304 ? {maxHeight: "110px"} : {}}
                                    width={240}
                                    height={70}
                                    sizes="240px"
                                />
                            ) : null}
                        </Link>

                        <div className={styles.info_header} style={{ color: cor_titulos }}>IMÓVEIS</div>
                        { (isSite2551 ? getSite2551TransactionOrder() : site?.transacoes)?.map((v: any, index: number) =>
                            v && site?.id != 2097 && site?.id != 2379 ?
                                <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/'+v.toLowerCase()+'/-/-/-/-')} key={index} passHref>
                                    <div
                                        style={{width: "100%"}}
                                        aria-label={`Botão para buscar imóveis de venda ${v == "aluguel" ? "alugar" : v.toLowerCase()}`}
                                        title={`Imóveis para ${v == "aluguel" ? "alugar" : v.toLowerCase()}`}
                                    >
                                        <div className={styles.info_body} style={{color: cor_letras}}>Imóveis para {v.toLowerCase() == "aluguel" ? "alugar" : v.toLowerCase()}</div>
                                    </div>
                                </Link>
                            :null
                        )}


                        {site?.id == "1952" ?
                            <a
                                href={"https://mkt.executiveimobiliaria.com.br/mkt-executiveimobiliaria-com-br/consorcio"}
                                aria-label={`Botão para navegar a página de Consórcio Imobiliário`}
                                title={`Clique aqui para ver as opções de Consórcio Imobiliário`}
                                style={{width: "100%"}}
                            >
                                <div className={styles.info_body} style={{color: cor_letras}}>Consórcio imobiliário</div>
                            </a>
                        : null
                        }

                        { favorito?.length > 0 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite(renderText())} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para navegar a lista de imóveis marcados com favoritos`}
                                    title={`Clique aqui para ver seus imóveis favoritos`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Favoritos</div>
                                </div>
                            </Link>
                        : null }

                        { vips2 ?
                            <Link prefetch={false} style={{width: "100%"}} href={vips2} target="_blank" rel="noopener noreferrer" passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para navegar a lista de imóveis exclusivos`}
                                    title={`Clique aqui para ver seus imóveis exclusivos`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Imóveis exclusivos</div>
                                </div>
                            </Link>
                        : null }
                        { site?.id == 2059 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/-?categoria=9999')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para navegar a lista de imóveis Exclusivos`}
                                    title={`Clique aqui para ver os imóveis Exclusivos`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Imóveis exclusivos</div>
                                </div>
                            </Link>
                        : null }
                        { site?.id == 2097 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/casa-em-condominio+casa-a-venda-em-condominio+casa-em-condominio-%7C-lancamento')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Acessar lista de casas em condomínio`}
                                    title={`Acessar lista de casas em condomínio`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Casas em condomínio</div>
                                </div>
                            </Link>
                        : null }
                        { site?.id == 2097 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/casa-fora-de-condominio')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Acessar lista de casas fora de condomínio`}
                                    title={`Acessar lista de casas fora de condomínio`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Casas avulsas imóvel novo</div>
                                </div>
                            </Link>
                        : null }
                        { site?.id == 2097 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/apartamentos')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Acessar lista de apartamentos`}
                                    title={`Acessar lista de apartamentos`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Apartamentos</div>
                                </div>
                            </Link>
                        : null }
                        { site?.id == 2097 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/-?categoria=18')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Acessar lista de Imóveis usados`}
                                    title={`Acessar lista de Imóveis usados`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Imóvel usado</div>
                                </div>
                            </Link>
                        : null }
                        { site?.id == 2097 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/aparthause')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Acessar lista de Aparthause`}
                                    title={`Acessar lista de Aparthause`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>ApartHause</div>
                                </div>
                            </Link>
                        : null }
                        { site?.id == 2097 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/lotes')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Acessar lista de Lotes`}
                                    title={`Acessar lista de Lotes`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Lotes</div>
                                </div>
                            </Link>
                        : null }
                        { site?.promocao && site?.id != 2097 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/-?promocao=1')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para navegar a lista de imóveis em promoção`}
                                    title={`Clique aqui para ver os imóveis em promoção`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>{isNovember ? "Black November" : site?.id == "1630" ? "Off Market" : "Imóveis em Promoção"}</div>
                                </div>
                            </Link>
                        : null }
                        { menus?.map((v: DrawerMenuItem, cont: number) =>
                            v?.Disponivel && !v?.link && v?.titulo != "Equipe" && !shouldHideFromPropertiesSection(v) && shouldRenderUniqueMenu(v) ?
                                site?.id == 2379 && v?.titulo == "A Perfil" ? 
                                <>
                                    <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/menu/'+v?.titulo)} key={cont} passHref>
                                        <div
                                            style={{width: "100%"}}
                                            aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                            title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                        >
                                            <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                        </div>
                                    </Link>
                                    <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/-')} key={"venda"} passHref>
                                        <div
                                            style={{width: "100%"}}
                                            aria-label={`Botão para buscar imóveis à venda`}
                                            title={`Imóveis para venda`}
                                        >
                                            <div className={styles.info_body} style={{color: cor_letras}}>Imóveis para venda</div>
                                        </div>
                                    </Link>
                                </>
                                :
                                <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/menu/'+v?.titulo)} key={cont} passHref>
                                    <div
                                        style={{width: "100%"}}
                                        aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                        title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                    >
                                        <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                    </div>
                                </Link>
                            :
                            v?.link && v?.Disponivel ?
                                v?.link.includes("/imove") && !shouldHideFromPropertiesSection(v) && shouldRenderUniqueMenu(v) ?
                                    site?.id == 2379 && v?.titulo == "A Perfil" ? 
                                    <>
                                        <Link prefetch={false} style={{width: "100%"}} href={withCodsite(v?.link)} key={v?.titulo} passHref>
                                            <div
                                                style={{width: "100%"}}
                                                aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                                title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                            >
                                                <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                            </div>
                                        </Link>
                                        <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/-')} key={"venda"} passHref>
                                            <div
                                                style={{width: "100%"}}
                                                aria-label={`Botão para buscar imóveis à venda`}
                                                title={`Imóveis para venda`}
                                            >
                                                <div className={styles.info_body} style={{color: cor_letras}}>Imóveis para venda</div>
                                            </div>
                                        </Link>
                                    </>
                                    :
                                    <Link prefetch={false} style={{width: "100%"}} href={withCodsite(v?.link)} key={v?.titulo} passHref>
                                        <div
                                            style={{width: "100%"}}
                                            aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                            title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                        >
                                            <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                        </div>
                                    </Link>
                                :null
                            :null
                        )}

                        {site?.id == "1952" ?
                            <>
                                <div className={styles.info_header} style={{color: cor_letras}}>EMPREENDIMENTOS</div>
                                <a
                                    href={"https://mkt.executiveimobiliaria.com.br/giardinomontemerano"}
                                    style={{width: "100%"}}
                                    aria-label={`Botão para navegar a página do empreendimento Giardino Montemerano`}
                                    title={`Clique aqui para navegar a página do empreendimento Giardino Montemerano`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Giardino Montemerano</div>
                                </a>
                            </>
                        : null
                        }


                        <div className={styles.info_header} style={site?.id != 2379 ? {color: cor_titulos} : {display: "none"}}>{isSite2551 ? 'SERVIÇOS ONLINE' : 'SERVIÇOS'}</div>
                        { isSite2551 ? getSite2551OrderedMenuEntries(site2551OnlineServiceSpecs).map(({ menu, displayTitle }, cont: number) =>
                            shouldRenderUniqueMenu(menu)
                                ? renderDrawerMenuLink(menu, `site-2551-service-${cont}`, getSite2551ServiceDisplayTitle(menu, displayTitle))
                                : null
                        ) : menus?.map((v: DrawerMenuItem, cont: number) =>
                            
                            v?.Disponivel && !v?.link && v?.titulo != "Equipe" && !shouldHideFromServicesSection(v) && shouldRenderUniqueMenu(v) ?
                                site?.id == 2379 && v?.titulo == "A Perfil" ? 
                                <>
                                    <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/menu/'+v?.titulo)} key={cont} passHref>
                                        <div
                                            style={{width: "100%"}}
                                            aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                            title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                        >
                                            <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                        </div>
                                    </Link>
                                    <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/-')} key={"venda"} passHref>
                                        <div
                                            style={{width: "100%"}}
                                            aria-label={`Botão para buscar imóveis à venda`}
                                            title={`Imóveis para venda`}
                                        >
                                            <div className={styles.info_body} style={{color: cor_letras}}>Imóveis para venda</div>
                                        </div>
                                    </Link>
                                </>
                                :
                                <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/menu/'+v?.titulo)} key={cont} passHref>
                                    <div
                                        style={{width: "100%"}}
                                        aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                        title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                    >
                                        <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                    </div>
                                </Link>
                            :
                            v?.link && v?.Disponivel ?
                                !v?.link.includes("/imove") && !shouldHideFromServicesSection(v) && shouldRenderUniqueMenu(v) ?
                                    site?.id == 2379 && v?.titulo == "A Perfil" ? 
                                    <>
                                        <Link prefetch={false} style={{width: "100%"}} href={withCodsite(v?.link)} key={v?.titulo} passHref>
                                            <div
                                                style={{width: "100%"}}
                                                aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                                title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                            >
                                                <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                            </div>
                                        </Link>
                                        <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/imoveis/venda/-/-/-/-')} key={"venda"} passHref>
                                            <div
                                                style={{width: "100%"}}
                                                aria-label={`Botão para buscar imóveis à venda`}
                                                title={`Imóveis para venda`}
                                            >
                                                <div className={styles.info_body} style={{color: cor_letras}}>Imóveis para venda</div>
                                            </div>
                                        </Link>
                                    </>
                                    :
                                    <Link prefetch={false} style={{width: "100%"}} href={withCodsite(v?.link)} key={v?.titulo} passHref>
                                        <div
                                            style={{width: "100%"}}
                                            aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                                            title={`Clique aqui para navegar navegar ao menu ${v?.titulo}`}
                                        >
                                            <div className={styles.info_body} style={{color: cor_letras}}>{ v?.titulo } </div>
                                        </div>
                                    </Link>
                                :null
                            :null
                        )}
                        {isSite2551 ? <div className={styles.info_header} style={{color: cor_titulos}}>INFORMAÇÕES GERAIS</div> : null}
                        {isSite2551 ? (
                            <>
                                {renderPrivacyLink()}
                                {renderTermsLink()}
                                {renderSite2551TeamLink()}
                                {renderBlogLink()}
                            </>
                        ) : renderBlogLink()}
                        {site?.id != 2379 ?
                            <>
                            {site?.id != "1925" && site?.id != "2016" && site?.id != "2377" && site?.id != "2243" && !isSite2551 ?
                            <>
                                <a
                                rel="noopener noreferrer"
                                href={
                                    site?.id == 2212
                                        ? "https://lp.igorcardosoimoveis.com.br/anuncie"
                                        : site?.id == 2133
                                        ? "https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link"
                                        : site?.id == 2378
                                        ? "https://mkt.elionaiconsultoria.com.br/"
                                        : site?.id == 1937
                                        ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Olá, gostaria de anunciar um imóvel.`
                                        : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Olá, gostaria de anunciar um imóvel.`
                                }
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    setTimeout(() => {
                                        window.open(
                                            site?.id == 2212
                                                ? "https://lp.igorcardosoimoveis.com.br/anuncie"
                                                : site?.id == 2133
                                                ? "https://docs.google.com/forms/d/e/1FAIpQLSfPZRaJZ6tlMCh6pH8o4CE4X-mDMvUaGgh92qf5eQ6mGN8O9w/viewform?usp=sf_link"
                                                : site?.id == 2378
                                                ? "https://mkt.elionaiconsultoria.com.br/"
                                                : site?.id == 1937
                                                ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Olá, gostaria de anunciar um imóvel.`
                                                : 
                                                site?.id == 2490
                                                ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Olá, gostaria de anunciar um imóvel. Pode me ajudar?`
                                                : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(/\D/g, '')}&text=Olá, gostaria de anunciar um imóvel.`,
                                            "_blank"
                                        );
                                    }, 300); // atraso para garantir trackLead
                                }}
                                aria-label={`Botão para anunciar seu imóvel`}
                                title={`Clique aqui para anunciar seu imóvel`}
                                className={styles.info_body}
                                style={{ color: cor_letras }}
                            >
                                Anuncie seu imóvel
                            </a>
                                <a
                                    rel="noopener noreferrer"
                                    href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=Oi, tenho uma  necessidade de um imóvel específico. Poderia me ajudar?`: 
                                            site?.id == "2490" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=Oi, tenho necessidade de um imóvel específico. Poderia me ajudar?`
                                            :
                                            `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=Oi, tenho uma  necessidade de um imóvel específico. Poderia me ajudar?`}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, null); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=Oi, tenho uma  necessidade de um imóvel específico. Poderia me ajudar?`: 
                                            site?.id == "2490" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=Oi, tenho necessidade de um imóvel específico. Poderia me ajudar?`
                                            :
                                            `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=Oi, tenho uma  necessidade de um imóvel específico. Poderia me ajudar?`,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    aria-label={`Botão para receber ajuda ao encontrar seu imóvel`}
                                    title={`Clique aqui para receber ajuda ao encontrar seu imóvel`}
                                    className={styles.info_body}
                                    style={{color: cor_letras}}
                                >
                                    {site?.id == 1630 ? "Construímos seu imóvel" : "Não encontrou seu imóvel?"}
                                </a>
                            </>
                        : null }
                        {site?.id != 2456 && !isSite2551 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/termos')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para ver os termos de uso`}
                                    title={`Clique aqui para ver os termos de uso`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>Termos de uso</div>
                                </div>
                            </Link>: null}
                        {site?.id != 2456 && !isSite2551 ?
                            <Link prefetch={false} style={{width: "100%"}} href={withCodsite('/politica')} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para ir a página Política de Privacidade`}
                                    title={`Clique aqui para ir a página Política de Privacidade`}
                                >
                                    <div className={styles.info_body} style={{color: cor_letras}}>
                                        Política de privacidade
                                    </div>
                                </div>
                            </Link> : null}
                        </>
                        : null}
                        {site?.id != 2379 ?
                        <>
                        <div className={styles.info_header} style={{color: cor_titulos}}>{isSite2551 ? 'FALE CONOSCO' : 'CONTATO'}</div>
                        {isSite2551 ? getSite2551OrderedMenus(site2551ContactTitles).map((v: DrawerMenuItem, cont: number) =>
                            shouldShowInContactSection(v) && shouldRenderUniqueMenu(v) ? renderDrawerMenuLink(v, `site-2551-contact-${cont}`, normalizeMenuTitle(v?.titulo) === 'contato' ? 'Contatos' : v?.titulo) : null
                        ) : null}
                        {isSite2551 ? getSite2551OrderedMenuEntries(site2551ContactExtraSpecs).map(({ menu, displayTitle }, cont: number) =>
                            shouldRenderUniqueMenu(menu)
                                ? renderDrawerMenuLink(menu, `site-2551-contact-extra-${cont}`, getSite2551ServiceDisplayTitle(menu, displayTitle))
                                : null
                        ) : null}
                        {!isSite2551 && menus?.filter((v: any) => v?.titulo == "Equipe").length > 0 ?
                            <Link prefetch={false} href={withCodsite('/menu/Equipe')} style={{width: "100%"}} passHref>
                                <div
                                    style={{width: "100%"}}
                                    aria-label={`Botão para ir a página Equipe`}
                                    title={`Clique aqui para ir a página Equipe`}
                                >
                                    <div className={styles.info_body} onClick={closeDrawer} style={{color: cor_letras}}>Equipe</div>
                                </div>
                            </Link> : null
                        }
                        {site?.id == "1952" ?
                        <>
                            <div className={styles.info_body} style={{color: cor_letras}}>Email: venda@executiveimobiliaria.com.br</div>
                        </>
                        : null
                        }
                        {!isSite2551 ? <a
                            rel="noopener noreferrer"
                            href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : 
                                    site?.id == "2490" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=Olá, visitei o site e estou precisando de atendimento. Pode me ajudar?`
                                    :
                                    `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, null); // 🔥 Registra o evento Lead

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == "1937" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`
                                    : 
                                    site?.id == "2490" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=Olá, visitei o site e estou precisando de atendimento. Pode me ajudar?`
                                    :
                                    `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                        /\D/g,
                                        ''
                                    )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                            aria-label={`Botão para falar com a aquipe de atendimento`}
                            title={`Clique aqui para falar com a aquipe de atendimento`}
                            className={styles.info_body}
                            style={{color: cor_letras}}
                        >
                            Fale Conosco
                        </a> : null}

                        {site?.Dados?.tel1 && site?.tel1_whats ? (
                            <a
                                rel="noopener noreferrer"
                                href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel1?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                aria-label={`Botão para enviar mensagem no WhatsApp 1 da imobiliária`}
                                title={`Clique aqui para enviar mensagem no WhatsApp 1 da imobiliária`}
                                className={styles.contatoNumero}
                                style={{color: cor_letras}}
                            >
                                {site?.Dados?.tel1}
                            </a>
                        ) : null}
                        {site?.Dados?.tel2 && site?.tel2_whats ? (
                            <a
                                rel="noopener noreferrer"
                                href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel2?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` :`https://api.whatsapp.com/send?phone=55${site?.Dados?.tel2?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel2?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` :`https://api.whatsapp.com/send?phone=55${site?.Dados?.tel2?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                aria-label={`Botão para enviar mensagem no WhatsApp 2 da imobiliária`}
                                title={`Clique aqui para enviar mensagem no WhatsApp 2 da imobiliária`}
                                className={styles.contatoNumero}
                                style={{color: cor_letras}}
                            >
                                {site?.Dados?.tel2}
                            </a>
                        ) : null}
                        {site?.Dados?.tel3 && site?.tel3_whats ? (
                            <a
                                rel="noopener noreferrer"
                                href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel3?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel3?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel3?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel3?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                aria-label={`Botão para enviar mensagem no WhatsApp 3 da imobiliária`}
                                title={`Clique aqui para enviar mensagem no WhatsApp 3 da imobiliária`}
                                className={styles.contatoNumero}
                                style={{color: cor_letras}}
                            >
                                {site?.Dados?.tel3}
                            </a>
                        ) : null}
                        {site?.Dados?.tel4 && site?.tel4_whats ? (
                            <a
                                rel="noopener noreferrer"
                                href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel4?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel4?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${site?.Dados?.tel4?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`: `https://api.whatsapp.com/send?phone=55${site?.Dados?.tel4?.replace(
                                            /\D/g,
                                            ''
                                        )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                aria-label={`Botão para enviar mensagem no WhatsApp 4 da imobiliária`}
                                title={`Clique aqui para enviar mensagem no WhatsApp 4 da imobiliária`}
                                className={styles.contatoNumero}
                                style={{color: cor_letras}}
                            >
                                {site?.Dados?.tel4}
                            </a>
                        ) : null}
                        </>
                        : null}
                    </div>
                    <div>
                        {site?.id == 1630 ? (
                            <div className={styles.footerFlags}>
                                {footerFlags.map((flag) => (
                                    <img
                                        key={flag.code}
                                        src={`https://flagcdn.com/w20/${flag.code}.png`}
                                        alt={`Bandeira ${flag.label}`}
                                        width={20}
                                        height={15}
                                        className={styles.footerFlag}
                                        loading="lazy"
                                    />
                                ))}
                            </div>
                        ) : null}
                        <div className={styles.container_network}>
                            <div>
                                {site?.Dados?.youtube ? (
                                    <a
                                        rel="noreferrer"
                                        href={site?.Dados?.youtube}
                                        onClick={async (e) => {
                                            e.preventDefault(); // Evita o redirecionamento automático

                                            trackLead(site, null); // 🔥 Registra o evento Lead

                                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                            setTimeout(() => {
                                            window.open(
                                                site?.Dados?.youtube,
                                                "_blank"
                                            );
                                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                        }}
                                        aria-label={`Botão para acessar o nosso canal no Youtube`}
                                        title={`Clique aqui para acessar o nosso canal no Youtube`}
                                        className={styles.network}
                                    >
                                        <svg
                                            viewBox="0 0 24 24"
                                            height={24}
                                            width={24}
                                        >
                                            <path
                                                fill="#fff"
                                                d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
                                            ></path>
                                        </svg>
                                    </a>
                                ) : null}
                                {site?.Dados?.instagram ? (
                                    <a
                                        href={site?.Dados?.instagram}
                                        onClick={async (e) => {
                                            e.preventDefault(); // Evita o redirecionamento automático

                                            trackLead(site, null); // 🔥 Registra o evento Lead

                                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                            setTimeout(() => {
                                            window.open(
                                                site?.Dados?.instagram,
                                                "_blank"
                                            );
                                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                        }}
                                        rel="noreferrer"
                                        aria-label={`Botão para acessar o nosso perfil no Instagram`}
                                        title={`Clique aqui para acessar o nosso perfil no Instagram`}
                                        className={styles.network}
                                    >
                                        <svg
                                            viewBox="0 0 24 24"
                                            height={24}
                                            width={24}
                                        >
                                            <path
                                                fill="#fff"
                                                d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
                                            ></path>
                                        </svg>
                                    </a>
                                ) : null}
                                {site?.Dados?.facebook ? (
                                    <a
                                        href={site?.Dados?.facebook}
                                        onClick={async (e) => {
                                            e.preventDefault(); // Evita o redirecionamento automático

                                            trackLead(site, null); // 🔥 Registra o evento Lead

                                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                            setTimeout(() => {
                                            window.open(
                                                site?.Dados?.facebook,
                                                "_blank"
                                            );
                                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                        }}
                                        rel="noreferrer"
                                        aria-label={`Botão para acessar o nosso perfil no Facebook`}
                                        title={`Clique aqui para acessar o nosso perfil no Facebook`}
                                        className={styles.network}
                                    >
                                        <svg
                                            viewBox="0 0 24 24"
                                            height={24}
                                            width={24}
                                        >
                                            <path
                                                fill="#fff"
                                                d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z"
                                            ></path>
                                        </svg>
                                    </a>
                                ) : null}
                            </div>
                            
                            {site?.id != 2243 ?
                                <a
                                    className={styles.contact}
                                    rel="noopener noreferrer"
                                    href={site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel1 ||
                                        site?.Dados?.tel2 ||
                                        site?.Dados?.tel3 ||
                                        site?.Dados?.tel4
                                    )?.replace(/\D/g, '')}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${(
                                        site?.Dados?.tel1 ||
                                        site?.Dados?.tel2 ||
                                        site?.Dados?.tel3 ||
                                        site?.Dados?.tel4
                                    )?.replace(/\D/g, '')}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, null); // 🔥 Registra o evento Lead

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.id == "1937" ? `https://api.whatsapp.com/send?phone=${(
                                                site?.Dados?.tel1 ||
                                                site?.Dados?.tel2 ||
                                                site?.Dados?.tel3 ||
                                                site?.Dados?.tel4
                                            )?.replace(/\D/g, '')}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}` : `https://api.whatsapp.com/send?phone=55${(
                                                site?.Dados?.tel1 ||
                                                site?.Dados?.tel2 ||
                                                site?.Dados?.tel3 ||
                                                site?.Dados?.tel4
                                            )?.replace(/\D/g, '')}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"}`,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    aria-label={`Botão para falar com a aquipe de atendimento`}
                                    title={`Clique aqui para falar com a aquipe de atendimento`}
                                >
                                    Whatsapp
                                </a>
                            :null}
                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    if (activeDrawer === false) {
        return (
            <div className={styles.container_all_drawer_close}>
                <div
                    onClick={closeDrawer}
                    className={styles.container_background}
                />
                <div className={styles.container_drawer}>
                    {logoSrcClosed ? (
                        <Image
                            src={logoSrcClosed}
                            alt={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                            title={`Imobiliária ${site?.Dados?.empresa} - ${site?.Dados?.cidade}`}
                            className={styles.logo_welcome}
                            width={240}
                            height={70}
                            sizes="240px"
                        />
                    ) : null}
                </div>
            </div>
        );
    }
};

export default DrawerComponent;
